/*
 * Temporary UpCart workaround (2026-10-20).
 *
 * UpCart's editor shows the Announcements bar as Active with a 10:00 timer,
 * but those two settings never reach the storefront (it keeps loading
 * announcementModule: false and announcementTimer: "0"), so the bar doesn't
 * show. This turns it on with a 10-minute timer before UpCart starts.
 *
 * Runs as a deferred script from <head>: after UpCart's inline settings
 * script, before UpCart's own deferred bundle. Remove it (and its tag in
 * layout/theme.liquid) once UpCart saves these settings properly; while it's
 * here, the Announcements on/off switch and timer in UpCart are ignored.
 */
(function () {
  var settings = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
  if (!settings) return;

  settings.announcementModule = true;
  settings.announcementTimer = '10:00';
})();
